import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <header className="bg-white border-b border-zinc-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-zinc-100 transition-colors" data-testid="privacy-back-btn">
            <ArrowLeft size={24} weight="bold" className="text-zinc-700" />
          </button>
          <h1 className="text-lg sm:text-xl font-black text-zinc-900 tracking-tight">Informativa Privacy</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <div className="prose prose-zinc prose-sm max-w-none">
          <p className="text-xs text-zinc-400 uppercase tracking-wider font-bold mb-6">Informativa ai sensi degli artt. 13-14 del Regolamento UE 2016/679 (GDPR)</p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">1. Titolare del Trattamento</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            Sergio Battelli, titolare della ditta individuale <strong>Vita da Host</strong> (P.IVA 02903680995), con sede in Genova.
            <br />Contatto: tramite l'applicazione.
          </p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">2. Dati raccolti e finalit&agrave;</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-2">La piattaforma raccoglie i seguenti dati:</p>
          <ul className="list-disc list-inside text-sm text-zinc-600 space-y-1 mb-4 pl-2">
            <li><strong>Dati di registrazione (Host):</strong> Nome, email, password (hash crittografico). Finalit&agrave;: erogazione del servizio e gestione account.</li>
            <li><strong>Dati contrattuali (inseriti dall'Host):</strong> Dati proprietario, dati alloggio, dati soggiorno. Finalit&agrave;: generazione del contratto PDF.</li>
            <li><strong>Dati dell'ospite (inseriti dall'ospite):</strong> Nome, luogo/data nascita, residenza, codice fiscale, documento, firma grafica. Finalit&agrave;: compilazione e firma del contratto.</li>
            <li><strong>Log minimali:</strong> Nome e iniziale cognome ospite, date soggiorno, numero ospiti. Finalit&agrave;: storico operazioni per l'Host.</li>
          </ul>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">3. Trattamento dati dell'ospite</h2>
          <div className="bg-zinc-50 border border-zinc-200 p-4 mb-4">
            <p className="text-sm text-zinc-700 leading-relaxed font-medium">
              La piattaforma "Locazione Turistica" <strong>non archivia, conserva, n&eacute; tratta</strong> i dati personali completi dell'ospite oltre le 24 ore dalla firma. Il software agisce esclusivamente come strumento tecnico per la generazione del documento in tempo reale.
            </p>
            <p className="text-sm text-zinc-600 leading-relaxed mt-2">
              Il <strong>Titolare del Trattamento dei dati dell'ospite &egrave; l'Host</strong>, il quale &egrave; l'unico responsabile della conservazione e della protezione dei dati, in conformit&agrave; al GDPR.
            </p>
          </div>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">4. Conservazione dei dati</h2>
          <ul className="list-disc list-inside text-sm text-zinc-600 space-y-1 mb-4 pl-2">
            <li><strong>Contratti PDF:</strong> Eliminati automaticamente dal server dopo 24 ore dalla firma.</li>
            <li><strong>Dati account Host:</strong> Conservati per tutta la durata dell'abbonamento + 30 giorni dopo la cessazione.</li>
            <li><strong>Log operazioni:</strong> Conservati per tutta la durata dell'account Host.</li>
            <li><strong>Dati di pagamento:</strong> Gestiti interamente da Stripe. Non conserviamo numeri di carta o dati bancari.</li>
          </ul>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">5. Cookie e tracciamento</h2>
          <ul className="list-disc list-inside text-sm text-zinc-600 space-y-1 mb-4 pl-2">
            <li><strong>Cookie tecnici:</strong> Necessari al funzionamento dell'applicazione (autenticazione).</li>
            <li><strong>Cookie di analisi (PostHog):</strong> Attivati solo previo consenso esplicito dell'utente tramite il banner cookie. Utilizzati per analisi statistiche anonime sull'utilizzo della piattaforma.</li>
          </ul>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            L'utente pu&ograve; revocare il consenso ai cookie in qualsiasi momento cancellando i dati del browser.
          </p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">6. Diritti dell'interessato (artt. 15-22 GDPR)</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-2">L'utente ha diritto a:</p>
          <ul className="list-disc list-inside text-sm text-zinc-600 space-y-1 mb-4 pl-2">
            <li><strong>Accesso:</strong> Ottenere conferma del trattamento e copia dei dati.</li>
            <li><strong>Rettifica:</strong> Correggere dati inesatti o incompleti.</li>
            <li><strong>Cancellazione:</strong> Richiedere l'eliminazione di tutti i propri dati ("diritto all'oblio"). Disponibile nella sezione Account.</li>
            <li><strong>Portabilit&agrave;:</strong> Scaricare i propri contratti in formato PDF.</li>
            <li><strong>Opposizione:</strong> Opporsi al trattamento per finalit&agrave; di analisi (rifiutando i cookie).</li>
          </ul>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">7. Base giuridica</h2>
          <ul className="list-disc list-inside text-sm text-zinc-600 space-y-1 mb-4 pl-2">
            <li><strong>Esecuzione contrattuale</strong> (art. 6.1.b GDPR): per l'erogazione del servizio.</li>
            <li><strong>Consenso</strong> (art. 6.1.a GDPR): per i cookie di analisi.</li>
            <li><strong>Obbligo legale</strong> (art. 6.1.c GDPR): per gli adempimenti fiscali.</li>
          </ul>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">8. Sicurezza</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            Le password sono archiviate con hash crittografico (bcrypt). La connessione &egrave; protetta da HTTPS/TLS. I dati sensibili dei contratti vengono eliminati dopo 24 ore. I pagamenti sono gestiti da Stripe con standard PCI-DSS.
          </p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">9. Autorit&agrave; di controllo</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            L'utente ha diritto di proporre reclamo al <strong>Garante per la protezione dei dati personali</strong> (www.garanteprivacy.it).
          </p>

          <div className="mt-10 pt-8 border-t border-zinc-200">
            <p className="text-xs text-zinc-400 text-center">
              Ultimo aggiornamento: 5 Aprile 2026
              <br />&copy; 2026 Sergio Battelli &mdash; Vita da Host (P.IVA 02903680995) &mdash; Genova
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
